<template>
    <div class="modal fade" :id="id" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdrop" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <form @submit.prevent="submitForm" class="form">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">{{ edit ? $t('events.stands.modification') : $t('events.stands.creation') }}</h5>
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click="closeModal">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor" />
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor" />
                    </svg>
                  </span>
              </div>
            </div>
  
            <div class="modal-body">
                <RequiredText></RequiredText>
                <Input
                      container-class="form-group mb-5"
                      :name="`stand_name_`+id"
                      type="text"
                      :label="$t('events.stands.name')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      size="lg"
                      :isRequired="true" 
                      :placeholder="$t('events.stands.name')"
                      v-model="formData.name"
                  />
                  <Input
                      container-class="form-group mb-5"
                      :name="`stand_number_`+id"
                      type="text"
                      :label="$t('events.stands.number')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      size="lg"
                      :isRequired="true" 
                      :placeholder="$t('events.stands.number')"
                      v-model="formData.number"
                  />
                  <Input
                      container-class="form-group mb-5"
                      :name="`stand_location_`+id"
                      type="text"
                      :label="$t('events.stands.location')"
                      labelClass="form-label fs-6 text-black"
                      :inputClass="'form-control form-control-lg form-control-solid'"
                      size="lg"
                      :isRequired="false" 
                      :placeholder="$t('events.stands.location')"
                      v-model="formData.location"
                  />
                  <Select2
                    :parent-id="'#'+id"
                    :is-required="false"
                    container-class="form-group"
                    :multiple="false"
                    :show-search="true"
                    :selectClass="'form-select form-control-lg form-select-solid'"
                    :name="'participator_'+id"
                    :label="$t('events.stands.participator')"
                    label-class="form-label fs-6 text-black"
                    :placeholder-text="$t('events.stands.participator_placeholder')"
                    v-model="formData.participator_id"
                  >
                    <option v-for="(participator, index) in participators" :key="index" :value="participator.id">
                      {{ participator.firstname }} {{ participator.lastname }}
                    </option>
                  </Select2>

                  <Select2
                    :parent-id="'#'+id"
                    :is-required="false"
                    container-class="form-group"
                    :multiple="true"
                    :show-search="true"
                    :selectClass="'form-select form-control-lg form-select-solid'"
                    :name="'members_'+id"
                    :label="$t('events.stands.members')"
                    label-class="form-label fs-6 text-black"
                    v-model="formData.members"
                  >
                    <option v-for="(member, index) in members" :key="index" :value="member.id">
                      {{ member.firstname }} {{ member.lastname }}
                    </option>
                  </Select2>
            </div>

            <div class="modal-footer">
              <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
              <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
            </div>
          </div>
        </form>
      </div>
    </div>
</template>

<script setup>
    import {ref, defineProps, onMounted, computed, watch} from 'vue'
    import Button from "@/components/Button";
    import Input from "@/components/Input.vue";
    import {useStore} from "vuex";
    import RequiredText from "@/components/RequiredText.vue"
    import Select2 from '@/components/Select2.vue';
    import {useRoute} from "vue-router";

    const emits = defineEmits(["load"]);
    
    const props = defineProps({
        id: {
            type: String,
            required: true
        },
        form: {
            type: Object,
            default: {
              id: '',
              event_id: '',
              name: '',
              number: '',
              location: '',
              participator_id: '',
              members: []
            }
        },
        edit: {
            type: Boolean,
            default: false
        }
    })
  
    const store = useStore()
    const route = useRoute()

    const isLoading  = ref(false)
    const formData = ref(props.form)

    const participators = computed(() => store.getters['events/getEventParticipators'])
    const members = computed(() => participators.value?.filter(el => el.id != formData.value.participator_id))

    watch(() => props.form, (value) => {
        if(value) formData.value = value
    })

    watch(() => route.query.tab, (value) => {
      if(value) {
          loadData()
      }
    })
    
    function closeModal(){
      $('#'+props.id).modal('toggle')
    }
    
    function submitForm() {
        isLoading.value = true;
        let action = props.edit ? 'stands/updateStand' : 'stands/createStand'
        let message = props.edit ? 'events.stands.updated_successfully' : 'events.stands.created_successfully'
        
        formData.value.event_id = route.params.id

        store
          .dispatch(action, formData.value)
          .then(() => {
              isLoading.value = false;
              emits("load");
              closeModal();
              formData.value = {}
      
              window.toastr["success"](i18n.global.t(message));
          })
          .catch((e) => {

              isLoading.value = false;
          });
    }

    function loadData() {
      store.dispatch('events/loadParticipators', route.params.id)
    }

    onMounted(() => {
      if(route.query.tab == 'tab-stands') loadData()
    })
</script>

<style scoped>
  .icon-wrapper {
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .icon-wrapper i {
    position: relative;
    font-size: 1.5em;
  }

  .icon-wrapper .icon-text {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 9px;
    color: white;
    margin-top: 8px;
  }
</style>